var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import React from "react";
export default React.forwardRef((_a, ref) => {
    var { noCellBorder, type = "default", height, isDisabled, isFocusable, className = "" } = _a, otherProps = __rest(_a, ["noCellBorder", "type", "height", "isDisabled", "isFocusable", "className"]);
    const { root } = useStyles({
        noCellBorder,
        type,
        height,
        isDisabled,
        isFocusable,
    });
    return React.createElement("tr", Object.assign({ ref: ref, className: className + " " + root }, otherProps));
});
const useStyles = makeStyles((theme) => ({
    root: ({ noCellBorder, type = "default", 
    // isDisabled,
    isFocusable, height = "auto", }) => {
        const styles = {
            display: "flex",
            height,
            position: "relative",
            pointerEvents: "auto",
        };
        if (type === "head")
            return styles;
        else if (isFocusable)
            return Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: "#f5f9ff",
                }, "&:focus": {
                    outline: `2px ${theme.palette.border.focus}`,
                } });
        return Object.assign(Object.assign({}, styles), { borderBottom: !noCellBorder ? "1px solid #ebedf0" : "", "&:first-child": {
                marginTop: !noCellBorder ? "32px" : 0,
            }, "&:last-child": {
                marginBottom: !noCellBorder ? "80px" : 0,
            }, boxSizing: "border-box" });
    },
}));
//# sourceMappingURL=FTLTableRow.js.map